import { Component, OnInit, effect, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { finalize } from 'rxjs';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { ContentType } from '../../enum/content-type.enum';
import { PrivacyPolicyService } from '../../../privacy-policy/service/privacy-policy.service';
import { Content } from '../../models/content.type';
import { withCorrectedLanguages } from '../../utils/localized-content.util';

@Component({
  selector: 'taly-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  providers: [PrivacyPolicyService],
  standalone: false,
})
export class PrivacyPolicyCommonComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  private privacyService = inject(PrivacyPolicyService);
  private sanitizer = inject(DomSanitizer);

  textDirection!: string;
  content?: Content;
  isLoading = true;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getPrivacyPolicy();
  }

  getPrivacyPolicy() {
    this.isLoading = true;

    this.privacyService
      .getPrivacyPolicy(ContentType.PRIVACY_POLICY)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (resp) => {
          this.content = withCorrectedLanguages(resp);
        },
        error: (err) => {
          this.transferSignal.showMessage('error', err?.message || err);
        },
      });
  }

  sanitizerContent(htmlContent: any) {
    if (htmlContent) {
      return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    } else {
      return '';
    }
  }
}
